import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './DropNeedForm.jsx'

export default createSubmit(name)